import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Stack, Typography } from '@mui/material';
import { STATUS_OPTIONS_DESCRIPTION } from '../../../../constants/status';
import { KPI_KEYS, PRESET_LABELS } from '../constants';

const NsirMapaActiveFilters = ({
  localFilter,
  activeKpi,
  activePreset,
  onClearKpi,
  onClearPreset,
}) => {
  const chips = [];

  if (activePreset) {
    chips.push({
      key: `preset-${activePreset}`,
      label: PRESET_LABELS[activePreset] || activePreset,
      onDelete: onClearPreset,
    });
  }

  if (activeKpi && activeKpi !== KPI_KEYS.GPS_ERRORS) {
    const kpiLabels = {
      [KPI_KEYS.ANOMALIAS]: 'Anomalias',
      [KPI_KEYS.AGUARDANDO]: 'Aguardando inspeção',
      [KPI_KEYS.EM_INSPECAO]: 'Em inspeção',
      [KPI_KEYS.FINALIZADAS]: 'Finalizadas',
    };
    chips.push({
      key: `kpi-${activeKpi}`,
      label: kpiLabels[activeKpi] || activeKpi,
      onDelete: onClearKpi,
    });
  }

  if (localFilter?.malhaId?.length) {
    chips.push({
      key: 'malha',
      label: `${localFilter.malhaId.length} malha(s)`,
    });
  }

  if (localFilter?.municipioIbge?.length) {
    chips.push({
      key: 'municipio',
      label: `${localFilter.municipioIbge.length} município(s)`,
    });
  }

  if (localFilter?.status?.length) {
    const statusLabels = localFilter.status
      .map((s) => STATUS_OPTIONS_DESCRIPTION[s] || s)
      .slice(0, 2)
      .join(', ');
    const suffix = localFilter.status.length > 2
      ? ` +${localFilter.status.length - 2}`
      : '';
    chips.push({
      key: 'status',
      label: `Status: ${statusLabels}${suffix}`,
    });
  }

  if (chips.length === 0) return null;

  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
        Visualizando:
      </Typography>
      {chips.map((chip) => (
        <Chip
          key={chip.key}
          label={chip.label}
          size="small"
          variant="outlined"
          onDelete={chip.onDelete}
        />
      ))}
    </Stack>
  );
};

NsirMapaActiveFilters.propTypes = {
  localFilter: PropTypes.object.isRequired,
  activeKpi: PropTypes.string,
  activePreset: PropTypes.string,
  onClearKpi: PropTypes.func.isRequired,
  onClearPreset: PropTypes.func.isRequired,
};

NsirMapaActiveFilters.defaultProps = {
  activeKpi: null,
  activePreset: null,
};

export default NsirMapaActiveFilters;
